import React, { FC } from 'react';
import {
  enumValues,
  MediaType,
  useCurrentMediaType,
} from '@repo-level/core-front';

export interface ResponsiveProps {
  mobileS?: React.ReactNode | MediaType;
  mobile?: React.ReactNode | MediaType;
  tablet?: React.ReactNode | MediaType;
  desktop?: React.ReactNode | MediaType;
  desktopL?: React.ReactNode | MediaType;
}

export function isMediaType(x: any): x is MediaType {
  return typeof x === 'number' && enumValues(MediaType).includes(x);
}

export const Responsive: FC<ResponsiveProps> = ({
  mobileS,
  mobile,
  tablet,
  desktop,
  desktopL,
}) => {
  const currentType = useCurrentMediaType();

  if (typeof currentType === 'undefined') return null;

  function getComponentByType(type: MediaType) {
    switch (type) {
      case MediaType.DESKTOP_L:
        return desktopL;
      case MediaType.DESKTOP:
        return desktop;
      case MediaType.TABLET:
        return tablet;
      case MediaType.MOBILE:
        return mobile;
      case MediaType.MOBILE_S:
        return mobileS;
    }
  }

  let Component = getComponentByType(currentType);

  // you can pass for example tablet={MediaType.MOBILE}
  // and for tablet media mobile component will be used
  if (isMediaType(Component)) {
    Component = getComponentByType(Component);
  }

  return <>{Component}</>;
};
